import { Injectable } from '@angular/core';
import { CustomApp, WebhookTestrecordDto } from '../../dto';
import { Observable } from 'rxjs';
import { BaseApiService } from './index';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WebhookHeaderDto } from '../../dto/webhook-header.dto';

@Injectable({
  providedIn: 'root'
})
export class WebhooksApiService {
  private readonly url: string = 'service/contactcloud/webhooks';
  private readonly jobContactsUrl: string = 'service/contactcloud/job-contacts';
  private readonly testRecordUrl: string = 'service/contactcloud/webhooks/test-record';

  constructor(
      private readonly http: HttpClient,
      private readonly baseApiService: BaseApiService
  ) { }

  getAll(): Observable<any> {
    return this.baseApiService.get(`${this.url}/list`);
  }

  getAllCompanies(): Observable<any> {
    return this.baseApiService.get(`${this.url}/list?requestType=companies`);
  }

  getAllContacts(): Observable<any> {
    return this.baseApiService.get(`${this.url}/list?requestType=contacts`, { showError: true });
  }

  create(app: CustomApp) {
    return this.baseApiService.post(this.url, app, { showError: true });
  }

  delete(app: CustomApp) {
    return this.baseApiService.delete(`${this.url}/${app.id}`);
  }

  edit(app: CustomApp, id: string) {
    return this.baseApiService.post(`${this.url}/${id}`, app, { showError: true });
  }

  export(app: CustomApp, configuration) {
    return this.baseApiService.post(`${this.jobContactsUrl}/${app.id}`, configuration);
  }

  sendTestRecord(id: string): Observable<WebhookTestrecordDto> {
    return this.baseApiService.get<WebhookTestrecordDto>(`${this.testRecordUrl}/${id}`);
  }

  sendToWebhook(url: string, body: WebhookTestrecordDto, headersRef: WebhookHeaderDto[]): Observable<WebhookTestrecordDto> {
    const headerAcc: Record<string, string> = headersRef?.reduce((acc: Record<string, string>, header: WebhookHeaderDto) => ({
      ...acc,
      [header.header_key]: header.header_value,
    }), {});

    const headers: HttpHeaders = new HttpHeaders(headerAcc);

    return this.http.post<WebhookTestrecordDto>(url, body, { headers });
  }
}
